// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/font/gteestiprodisplay_regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../shared/font/gteestiprodisplay_bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GteDisplayBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayExtra";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
.enterNumber_form__mYCc\\+ {
  margin-top: 60px;
  margin-bottom: auto;
  display: flex;
  width: 100%;
  align-items: stretch;
}

.enterNumber_body__6VjgA {
  position: relative;
  height: 100vh;
}

.enterNumber_previousStep__jyD0r {
  position: absolute;
  top: 50px;
  left: 0;
}

.enterNumber_header__fFd5U {
  padding-top: 35%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.enterNumber_header__fFd5U h4 {
  font-family: GteDisplayExtra;
  font-size: 28px;
  color: #000;
}
.enterNumber_header__fFd5U p {
  color: #C2C2C2;
  font-family: GteDisplayLight;
  font-size: 14px;
  margin-top: 12px;
}

.enterNumber_container__yV1Ba {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.enterNumber_sendBtn__Ozsz6 {
  margin-top: 20px;
}
.enterNumber_sendBtn__Ozsz6 button {
  width: 100%;
  padding: 14px 0;
  text-align: center;
  color: #000;
  background: #C7FF24;
  font-size: 16px;
  line-height: 16px;
  font-family: GteDisplayBold;
  border-radius: 30px;
}
.enterNumber_sendBtn__Ozsz6 button:disabled {
  background: #FAFAFA;
  color: #C2C2C2;
}

.enterNumber_inputBody__FOnlj {
  display: block;
  width: 100%;
}
.enterNumber_inputBody__FOnlj input {
  background: #FAFAFA;
  width: 100%;
  padding: 17px 20px 12px 17px;
  border-radius: 0 30px 30px 0;
  outline: none;
  border: none;
  font-family: GteDisplayBold;
  font-weight: 500;
  font-size: 16px;
}
.enterNumber_inputBody__FOnlj input::placeholder {
  color: #C2C2C2;
}`, "",{"version":3,"sources":["webpack://./src/components/enterNumber/enterNumber.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AAGA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,oBAAA;AADF;;AAIA;EACE,kBAAA;EACA,aAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;AADF;;AAIA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AADF;AAGE;EACE,4BAAA;EACA,eAAA;EACA,WAAA;AADJ;AAIG;EACE,cAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;AAFL;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;AAIE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;AAFJ;AAGI;EACE,mBAAA;EACA,cAAA;AADN;;AAOA;EACE,cAAA;EACA,WAAA;AAJF;AAKE;EACE,mBAAA;EACA,WAAA;EACA,4BAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;AAHJ;AAII;EACE,cAAA;AAFN","sourcesContent":["@font-face {\r\n  font-family: \"GteDisplayBold\";\r\n  src: url('../../shared/font/gteestiprodisplay_regular.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"GteDisplayExtra\";\r\n  src: url('../../shared/font/gteestiprodisplay_bold.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n\r\n\r\n.form {\r\n  margin-top: 60px;\r\n  margin-bottom: auto;\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: stretch;\r\n}\r\n\r\n.body {\r\n  position: relative;\r\n  height: 100vh;\r\n}\r\n\r\n.previousStep {\r\n  position: absolute;\r\n  top: 50px;\r\n  left: 0;\r\n}\r\n\r\n.header {\r\n  padding-top: 35%;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  flex-direction: column;\r\n\r\n  h4 {\r\n    font-family: GteDisplayExtra;\r\n    font-size: 28px;\r\n    color: #000;\r\n  }\r\n\r\n   p {\r\n     color: #C2C2C2;\r\n     font-family: GteDisplayLight;\r\n     font-size: 14px;\r\n     margin-top: 12px;\r\n   }\r\n}\r\n\r\n.container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n.sendBtn {\r\n  margin-top: 20px;\r\n  button {\r\n    width: 100%;\r\n    padding: 14px 0;\r\n    text-align: center;\r\n    color: #000;\r\n    background: #C7FF24;\r\n    font-size: 16px;\r\n    line-height: 16px;\r\n    font-family: GteDisplayBold;\r\n    border-radius: 30px;\r\n    &:disabled {\r\n      background: #FAFAFA;\r\n      color: #C2C2C2;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n.inputBody {\r\n  display: block;\r\n  width: 100%;\r\n  input {\r\n    background: #FAFAFA;\r\n    width: 100%;\r\n    padding: 17px 20px 12px 17px;\r\n    border-radius: 0 30px 30px 0;\r\n    outline: none;\r\n    border: none;\r\n    font-family: GteDisplayBold;\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n    &::placeholder {\r\n      color: #C2C2C2;\r\n\r\n    }\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `enterNumber_form__mYCc+`,
	"body": `enterNumber_body__6VjgA`,
	"previousStep": `enterNumber_previousStep__jyD0r`,
	"header": `enterNumber_header__fFd5U`,
	"container": `enterNumber_container__yV1Ba`,
	"sendBtn": `enterNumber_sendBtn__Ozsz6`,
	"inputBody": `enterNumber_inputBody__FOnlj`
};
export default ___CSS_LOADER_EXPORT___;
